var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Gis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9998 35.3383L0 42.7594V47H47.9998V35.3383Z",
    fill: "#81D714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33.5714L26.8657 37.1053C26.5792 32.0165 29.015 28.2707 34.7463 28.9774C37.9702 22.6165 37.2538 17.6692 35.8209 14.4887L48 16.4765V33.5714Z",
    fill: "#19AA1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V7.06767L16.8358 9.89474C18.985 7.77444 28.6566 5.65414 34.388 12.3684L47.9998 14.4887V0H0Z",
    fill: "#FFB919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.075 37.0971L22.9257 37.4506C23.284 28.9774 18.9855 27.5639 14.3288 26.8571C11.4631 22.3338 12.896 15.1955 15.7616 12.7195C20.0601 8.48119 27.5825 8.48092 32.2392 12.7195C36.8959 17.6669 35.1048 24.0275 33.672 27.2078C26.1496 26.5014 24.7168 33.9171 25.075 37.0971Z",
    fill: "#0273F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1343 37.8119L0 41.3458V9.18797L14.6865 11.3083C10.0298 15.1955 9.67161 22.9699 13.2537 28.9774C19.7014 28.2706 21.4925 32.8647 21.1343 37.8119Z",
    fill: "#19AA1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Gis);
export default __webpack_public_path__ + "static/media/2gis.c412edc6bc9f32df4c5a094019af9a3b.svg";
export { ForwardRef as ReactComponent };